import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TicketSelectorOptions } from '@nx-ng/types';
import { TicketSelectorService } from '@modules/ticket-selector';
import { TicketsAndFaresStoreFacade } from '@modules/ticket-fares-store';
import { TICKET_ROUTE_MAP } from '../../constants/ticket-route-map';
import { TicketTypeKeys } from '../../types';
import { CoreFacade } from '@modules/core/core.facade';

@Component({
  selector: 'nx-ng-ticket-types-page',
  templateUrl: './ticket-types.component.html',
  styleUrls: ['./ticket-types.component.scss'],
})
export class TicketTypesComponent implements OnInit {
  @Input()
  content?: TicketSelectorOptions;

  @Output()
  selection: EventEmitter<string> = new EventEmitter<string>();

  showError = false;
  constructor(
    private service: TicketSelectorService,
    private router: Router,
    private ticketInfo: TicketsAndFaresStoreFacade,
    private coreFacade: CoreFacade
  ) {}

  ngOnInit(): void {
    this.content = this.service.getOrderedSelection();
    this.ticketInfo.loadTicketSelectors();
  }

  handleClick(titleKey: string): void {
    const nextRoute = TICKET_ROUTE_MAP[titleKey as TicketTypeKeys];
    if (nextRoute) {
      this.router.navigateByUrl(nextRoute);
    }
  }

  handleTechnicalDifficultiesClosed(canRetry: boolean) {
    if (canRetry) {
      this.coreFacade.retryAllFailedActions();
    }
  }

  handleShowError(showError: boolean) {
    this.showError = showError;
  }
}
